import { render } from "./Report8_0.vue?vue&type=template&id=93882260&scoped=true&ts=true"
import script from "./Report8_0.vue?vue&type=script&lang=ts"
export * from "./Report8_0.vue?vue&type=script&lang=ts"

import "./Report8_0.vue?vue&type=style&index=0&id=93882260&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93882260"]])

export default __exports__